import { GoDeviceDesktop } from "react-icons/go";
import { MdOutlineAppSettingsAlt, MdOutlineDesignServices } from "react-icons/md";
import { SiAdobeindesign } from "react-icons/si";

export const ABOUT = {
    title: "About Me",
    name: "Zobayer Hosen",
    description: "I am a web developer with a passion for building beautiful, responsive websites and applications. I have a background in graphic design and I am currently working on a career in web development. I have strong knowledge of web architecture and frontend latest technology as react with good skill of HTML,CSS, and Javascript or some basic styling framework such as bootstrap, Semantic UI etc.",
    exports: ['JavaScript', 'React', 'UI/UX'],
    image: "/Asset/me.jpg",
    services: [
        {
            title: "Frontend Development",
            text: "Built websites using React JS with redux and Tailwind CSS.",
            icon: <GoDeviceDesktop size={33} />
        },
        {
            title: "Web Development",
            text: "Built the company website with custom WordPress themes from scratch.",
            icon: <MdOutlineAppSettingsAlt size={33} />
        },
        {
            title: "UI/UX Design",
            text: "Designed the User Interface and the User Experience with figma.",
            icon: <MdOutlineDesignServices size={33} />
        },
        {
            title: "Web Design",
            text: "Design from figma, psd, xd to HTML Web site Design.",
            icon: <SiAdobeindesign size={33} />
        },
    ]
}